import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import { site } from "@/data/site";

export default function Impressum() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <Header solid />
      <main className="w-full px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-label text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Zurück zur Startseite
          </Link>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl font-semibold text-foreground-950">
            Impressum
          </h1>

          <div className="mt-10 space-y-8 font-body text-sm md:text-base leading-relaxed text-foreground-700">
            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="mt-3">
                {site.name}
                <br />
                Inhaber: {site.owner}
                <br />
                {site.street}
                <br />
                {site.city}
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">Kontakt</h2>
              <p className="mt-3">
                Telefon:{" "}
                <a href={site.phoneHref} className="text-primary-600 hover:underline cursor-pointer">
                  {site.phoneDisplay}
                </a>
                <br />
                E-Mail:{" "}
                <a href={site.emailHref} className="text-primary-600 hover:underline cursor-pointer">
                  {site.email}
                </a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
              </h2>
              <p className="mt-3">
                {site.owner}
                <br />
                {site.street}, {site.city}
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                Haftung für Inhalte
              </h2>
              <p className="mt-3">
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                Haftung für Links
              </h2>
              <p className="mt-3">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}